import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Globe, Lock, ArrowUpRight } from 'lucide-react';
import { cn, getCommunityPath } from '../utils';

const CommunityCard = ({ community }) => {
  if (!community) return null;

  const { id, name, members_count, privacy, type, tagline, description, coverImage, icon, slug } = community;
  const isPrivate = (privacy || type) === 'private';
  const members = members_count || community.members || 0;
  const desc = tagline || description || 'Collaborate and build the future together in this community hub.';

  return (
    <Link 
      to={getCommunityPath(community)} 
      className="bg-white border border-gray-100 rounded-3xl p-6 hover:shadow-2xl hover:shadow-brand-indigo/5 transition-all group cursor-pointer block text-center md:text-left shadow-sm h-full flex flex-col"
    >
      <div className="flex flex-col md:flex-row items-center gap-4 mb-5">
        <div className={cn(
          "w-16 h-16 rounded-2xl bg-gray-50 overflow-hidden shrink-0 flex items-center justify-center font-bold text-gray-300 text-xl shadow-inner group-hover:scale-105 transition-transform",
          !icon && !coverImage && "bg-brand-indigo text-white"
        )}>
          {(coverImage || icon) ? (
            <img src={coverImage || icon} alt={name} className="w-full h-full object-cover" />
          ) : (
            name?.substring(0, 2).toUpperCase() || 'CH'
          )}
        </div>
        <div className="min-w-0">
          <h3 className="font-bold text-gray-900 group-hover:text-brand-indigo transition-colors truncate text-xl leading-tight tracking-tight">{name}</h3>
          <div className="flex items-center justify-center md:justify-start gap-2.5 text-[10px] font-bold text-gray-400 uppercase tracking-[0.15em] mt-1.5 opacity-80">
            <div className="flex items-center gap-1.5">
              {isPrivate ? <Lock size={12} className="text-amber-500" /> : <Globe size={12} className="text-brand-indigo" />}
              {isPrivate ? 'Private' : 'Public'}
            </div>
            <span className="w-1 h-1 bg-gray-200 rounded-full"></span>
            <div className="flex items-center gap-1.5">
              <Users size={12} />
              {members} {members === 1 ? 'member' : 'members'}
            </div>
          </div>
        </div>
      </div>
      <p className="text-sm text-gray-500 font-medium line-clamp-2 mb-8 leading-relaxed">
        {desc}
      </p>
      <div className="w-full py-4 bg-brand-indigo/5 text-brand-indigo font-bold rounded-2xl group-hover:bg-brand-indigo group-hover:text-white transition-all text-center text-[10px] uppercase tracking-[0.15em] mt-auto flex items-center justify-center gap-2">
        Enter Hub <ArrowUpRight size={14} />
      </div>
    </Link>
  );
};

export default CommunityCard;
